import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import Loading from 'components/UI/Loading/Loading';
import DialogMessage from 'components/UI/DialogMessage/DialogMessage';

import { academyDataActions } from '../../../store/academy-slice';
import { checkCode, renewSuscription } from 'store/academy-actions';

import classes from './CodeSection.module.css';

const CodeSection = () => {
  const { t } = useTranslation(['access']);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);

  useEffect(() => {
    dispatch(
      academyDataActions.showBanner({
        showBanner: true
      })
    );
  }, []);
  const handleChange = () => {
    setCode(event.target.value);
  };

  const sendCode = () => {
    setLoading(true);
    (async () => {
      const codeData = await checkCode(
        code,
        dataAcademy.data.idAcademy
      );
      if (codeData) {
        const renewSuscriptionData = await renewSuscription(
          code,
          dataAcademy.data.idAcademy
        );
        if (renewSuscriptionData) {
          setLoading(false);
        }
        setTitle(t('success_code'));
        setMessage('');
        setOpenDialog(true);
        setLoading(false);
        setRedirect(true);
      } else {
        setTitle(t('code_not_valid'));
        setMessage(t('code_not_valid_info'));
        setOpenDialog(true);
        setLoading(false);
      }
    })();
  };

  const handleClose = () => {
    setOpenDialog(false);
    if (redirect) {
      window.location.href = `/${dataAcademy.data.shortName}`;
    }
  };

  return (
    <>
      <aside className={classes.codeSection}>
        <TextField
          id="outlined-textarea"
          label={t('code')}
          className={classes.textFieldCode}
          value={code}
          onChange={handleChange}
          margin="normal"
          variant="outlined"
        />
        <div className={classes.sendCodeBtnContainer}>
          {!loading ? (
            <Button
              className={`${
                code
                  ? classes.btnSendCode
                  : classes.btnSendCodeDisabled
              }`}
              disabled={!code}
              onClick={sendCode}
            >
              {t('send')}
            </Button>
          ) : (
            <Loading />
          )}
        </div>
      </aside>
      <aside className={classes.aditionalInfoContainer}>
        <p className={classes.aditionalText}>{t('any_doubt')}</p>
        <a
          href="http://ayuda.mayahii.com/"
          target="_blank"
          className={classes.aditionalLink}
          rel="noreferrer"
        >
          {t('help_center')}
        </a>
      </aside>
      <DialogMessage
        title={title}
        message={message}
        open={openDialog}
        handleClose={handleClose}
      />
    </>
  );
};

export default CodeSection;
